import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If requires admin/editor to access CMS
  if (requiredRole === 'admin' && user.role !== 'admin' && user.role !== 'editor') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
